{
    "InboundcallsHeader": "Chamadas de entrada",
    "InboundcallsAvgordervalueLabel": "Valor médio do pedido:",
    "InboundcallsStrikerateLabel": "Taxa de greve (chamadas por pedido):",
    "OutboundcallsHeader": "Chamadas externas",
    "OutboundcallsAvgordervalueLabel": "Valor médio do pedido:",
    "OutboundcallsStrikerateLabel": "Taxa de greve (chamadas por pedido):",
    "MonetaryCallAssignments_SectionHeader": "Atribuições de Chamadas Monetárias",
    "MonetaryCallAssignments_SectionPara": "Você pode controlar como as estatísticas de chamadas financeiras\/monetárias são calculadas atribuindo valores monetários ou de pedidos de vendas estimados a chamadas de entrada e saída bem-sucedidas, bem como especificando uma taxa de greve de chamadas como o número de chamadas por venda\/pedido.",
    "NAME": "MonetaryCallAssignments"
}